import { useState } from "react";
import StaffAttendanceForm from "./StaffAttendanceForm";
import StudentAttendanceForm from "./StudentAttendanceForm";

const Attendance = () => {
  const [activeTab, setActiveTab] = useState("student");

  const tabs = [
    { key: "student", label: "Student Attendance" },
    { key: "staff", label: "Staff Attendance" },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white shadow-md rounded-xl min-h-screen">
      <h1 className="text-4xl font-bold text-center mb-2">Attendance Dashboard</h1>
      <p className="text-center text-gray-500 mb-6">
        Mark attendance for students and staff in one place.
      </p>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-5 py-2 rounded-full font-medium transition ${
              activeTab === tab.key
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-gray-50 rounded-lg p-6 shadow-sm">
        {activeTab === "student" && <StudentAttendanceForm />}
        {activeTab === "staff" && <StaffAttendanceForm />}
      </div>
    </div>
  );
};

export default Attendance;
